import _slicedToArray from "/Users/gorkolas/Documents/www/indolora/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// creates a matcher function
export default function makeMatcher() {
  var makeRegexpFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pathToRegexp;
  var cache = {}; // obtains a cached regexp version of the pattern

  var getRegexp = function getRegexp(pattern) {
    return cache[pattern] || (cache[pattern] = makeRegexpFn(pattern));
  };

  return function (pattern, path) {
    var _getRegexp = getRegexp(pattern || ""),
        regexp = _getRegexp.regexp,
        keys = _getRegexp.keys;

    var out = regexp.exec(path);
    if (!out) return [false, null]; // formats an object with matched params

    var params = keys.reduce(function (params, key, i) {
      params[key.name] = out[i + 1];
      return params;
    }, {});
    return [true, params];
  };
} // escapes a regexp string (borrowed from path-to-regexp sources)
// https://github.com/pillarjs/path-to-regexp/blob/v3.0.0/index.js#L202

var escapeRx = function escapeRx(str) {
  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}; // returns a segment representation in RegExp based on flags
// adapted and simplified version from path-to-regexp sources


var rxForSegment = function rxForSegment(repeat, optional, prefix) {
  var capture = repeat ? "((?:[^\\/]+?)(?:\\/(?:[^\\/]+?))*)" : "([^\\/]+?)";
  if (optional && prefix) capture = "(?:\\/" + capture + ")";
  return capture + (optional ? "?" : "");
};

var pathToRegexp = function pathToRegexp(pattern) {
  var groupRx = /:([A-Za-z0-9_]+)([?+*]?)/g;
  var match = null,
      lastIndex = 0,
      keys = [],
      result = "";

  while ((match = groupRx.exec(pattern)) !== null) {
    var _match = match,
        _match2 = _slicedToArray(_match, 3),
        _ = _match2[0],
        segment = _match2[1],
        mod = _match2[2]; // :foo  [1]      (  )
    // :foo? [0 - 1]  ( o)
    // :foo+ [1 - ∞]  (r )
    // :foo* [0 - ∞]  (ro)


    var repeat = mod === "+" || mod === "*";
    var optional = mod === "?" || mod === "*";
    var prefix = optional && pattern[match.index - 1] === "/" ? 1 : 0;
    var prev = pattern.substring(lastIndex, match.index - prefix);
    keys.push({
      name: segment
    });
    lastIndex = groupRx.lastIndex;
    result += escapeRx(prev) + rxForSegment(repeat, optional, prefix);
  }

  result += escapeRx(pattern.substring(lastIndex));
  return {
    keys: keys,
    regexp: new RegExp("^" + result + "(?:\\/)?$", "i")
  };
};